import { render, staticRenderFns } from "./UserVideo.vue?vue&type=template&id=41a2d570&scoped=true&"
import script from "./UserVideo.vue?vue&type=script&lang=js&"
export * from "./UserVideo.vue?vue&type=script&lang=js&"
import style0 from "./UserVideo.vue?vue&type=style&index=0&id=41a2d570&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41a2d570",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/finnkelly/Code/Go Remote/remote-chat-finn/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('41a2d570')) {
      api.createRecord('41a2d570', component.options)
    } else {
      api.reload('41a2d570', component.options)
    }
    module.hot.accept("./UserVideo.vue?vue&type=template&id=41a2d570&scoped=true&", function () {
      api.rerender('41a2d570', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/GroupTeams/Common/User/UserVideo.vue"
export default component.exports